export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  props?: Record<string, string | boolean | undefined> & {
    className?: string;
    text?: string;
    html?: string;
  },
  children?: (HTMLElement | string)[]
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  if (props) {
    const { className, text, html, ...rest } = props;
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    if (html !== undefined) node.innerHTML = html;
    for (const [k, v] of Object.entries(rest)) {
      if (v === true) node.setAttribute(k, '');
      else if (v !== false && v !== undefined) node.setAttribute(k, String(v));
    }
  }
  if (children) {
    for (const c of children) {
      if (typeof c === 'string') node.appendChild(document.createTextNode(c));
      else node.appendChild(c);
    }
  }
  return node;
}

export function clear(node: HTMLElement): void {
  while (node.firstChild) node.removeChild(node.firstChild);
}
